module.exports = __webpack_public_path__ + "images/tour/activity_actions-b84b5fadb56abc6e79b61d8ed9bd88b1.gif";